import { IError } from '../../../../models/response/error';

interface IErrorProps {
  errors: IError;
}

const Errors = ({ errors }: IErrorProps) => (
  <ul>
    {errors &&
      Object.keys(errors).map((keyName) => (
        <li key={keyName}>
          <span
            style={{
              textAlign: 'right',
              color: '#ef4444',
              fontSize: '0.875rem',
              fontStyle: 'italic',
              marginTop: '0.25rem',
            }}
          >
            {errors[keyName].toString()}
          </span>
        </li>
      ))}
  </ul>
);

export default Errors;
